import React, { useState, useEffect } from 'react';
import axios from '../utils/axiosInstance';
import '../assets/css/adminpanel.css'; // Ensure appropriate CSS is included

const EmailClients = () => {
    const [emails, setEmails] = useState('');
    const [copySuccess, setCopySuccess] = useState('');

    useEffect(() => {
        const fetchEmails = async () => {
            try {
                console.log('Fetching emails...');
                const response = await axios.get('/admin/emails');
                if (response.data && response.data.emails) {
                    console.log('Fetched emails:', response.data.emails);
                    setEmails(response.data.emails);
                } else {
                    setEmails('No purchaser emails found.');
                }
            } catch (error) {
                console.error('Error fetching emails:', error);
                setEmails('Failed to fetch emails. Please ensure you are logged in as an admin.');
            }
        };

        fetchEmails();
    }, []);

    const handleCopy = () => {
        navigator.clipboard.writeText(emails)
            .then(() => {
                setCopySuccess('Emails copied to clipboard!');
                setTimeout(() => setCopySuccess(''), 3000);
            })
            .catch(() => setCopySuccess('Failed to copy emails.'));
    };

    return (
        <div className="admin-panel container">
            <header className="card admin-header">
                <h2>Email Clients</h2>
                <p>Copy all purchaser emails to send a mass email. Click the button below to copy them to your clipboard.</p>
            </header>
            <div className="card">
                <div className="button-container">
                    <button className="button button-primary" onClick={handleCopy}>
                        Copy to Clipboard
                    </button>
                </div>
                {copySuccess && <p className="success-message">{copySuccess}</p>}
                <div className="email-block">
                    <p>{emails || 'No emails available to display.'}</p>
                </div>
            </div>
        </div>
    );
};

export default EmailClients;